import initialState from './initialState';
import { CUSTOM_PARAMS_SET_VALUE, CUSTOM_PARAM_CHANGED, CUSTOM_PARAMS_SET_STATE } from '../constants/actionTypes';

export default function (state = initialState.customParams, action) {
  switch (action.type) {
    case CUSTOM_PARAMS_SET_STATE:
      return state.concat(action.payload);
    case CUSTOM_PARAMS_SET_VALUE:
      return state.concat(action.payload);
    case CUSTOM_PARAM_CHANGED:
      return state.map(cp => cp.key === action.payload.key ? Object.assign({}, cp, { value: action.payload.value }) : cp);
    default:
      return state;
  }
}

